import { render, staticRenderFns } from "./PrestationsForm.vue?vue&type=template&id=75d31da6"
import script from "./PrestationsForm.vue?vue&type=script&lang=js"
export * from "./PrestationsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports